import { render, staticRenderFns } from "./singleGoodsItem.vue?vue&type=template&id=7d944255&scoped=true&"
import script from "./singleGoodsItem.vue?vue&type=script&lang=js&"
export * from "./singleGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./singleGoodsItem.vue?vue&type=style&index=0&id=7d944255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d944255",
  null
  
)

export default component.exports